import React from 'react';
import { Route, Redirect } from 'react-router';
import { observer } from "mobx-react";
import store from '../components/Stores/SurveyStore'
import { AuthConsumer } from "../Providers/AuthProvider";
import { checkIfAnalyst } from '../Services/IBS/IbsService';

   
const PrivateRoute = observer(({ component: Component, allowIfPageExists,allowClientAccess, ...rest }) => {
    //if analyst or client user with access to this page 
    //let allowForUser = store.availPageTitles.includes(allowIfPageExists);
    let allowForUser = allowIfPageExists ? store.availPageTitles.some(page => page.toLowerCase() === allowIfPageExists.toLowerCase()) : false;
    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    if (checkIfAnalyst() || allowForUser || allowClientAccess) {
                        return <Component {...props} />;
                    } else {
                        return <span></span>;

                    }
                } else {
                    signinRedirect();
                    return <span></span>;
                }
            }}
        </AuthConsumer>
    );
    return <Route {...rest} render={renderFn(Component)} />;
  

});

export default PrivateRoute;
